var installedModules = {};
var moduleToHandlerMapping = {
	33775: {
		getter: () => (__webpack_require__.e(41).then(() => (() => (__webpack_require__(14041))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "18.2.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react",
	},
	25021: {
		getter: () => (__webpack_require__.e(144).then(() => (() => (__webpack_require__(43144))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "18.2.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-dom",
	},
	24718: {
		getter: () => (__webpack_require__.e(914).then(() => (() => (__webpack_require__(11914))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "18.2.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react",
	},
	46840: {
		getter: () => (__webpack_require__.e(782).then(() => (() => (__webpack_require__(83782))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "6.21.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-router-dom",
	}
};
// no consumes in initial chunks
var chunkMapping = {
	"21": [
		25021
	],
	"676": [
		46840
	],
	"718": [
		24718
	],
	"775": [
		33775
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping: moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}